import React, { useEffect, useState } from "react";
import "./productFilter.scss";
import {
  AppBar,
  Avatar,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  TextField,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";

// Date Picker
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// Date Picker

// Icon
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import categoryStore from "../../../stores/categoryStore";
import productStore from "../../../stores/productStore";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ProductFilter = ({
  categoryID,
  setCategoryID,
  staringCreateAtDate,
  setStaringCreateAtDate,
  endingCreateAtDate,
  setEndingCreateAtDate,
  staringUpdateAtDate,
  setStaringUpdateAtDate,
  endingUpdateAtDate,
  setEndingUpdateAtDate,
  staringPrice,
  setStaringPrice,
  endingPrice,
  setEndingPrice,
  publish,
  setPublish,
}) => {
  const max_width600 = useMediaQuery("(max-width:600px)");
  const [open, setOpen] = useState(false);
  const [endingRequestDateError, setEndingRequestDateError] = useState(false);
  const [endingReturnDateError, setEndingReturnDateError] = useState(false);
  const [endingPriceError, setEndingPriceError] = useState(false);
  const todayDate = new Date();
  const ProductStore = productStore();
  const CategoryStore = categoryStore();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleApply = () => {
    let flag = true;
    if (
      categoryID === "" &&
      staringCreateAtDate === null &&
      endingCreateAtDate === null &&
      staringUpdateAtDate === null &&
      endingUpdateAtDate === null &&
      staringPrice === "" &&
      endingPrice === "" &&
      publish === ""
    ) {
      ProductStore.setProductFilterApply({ value: 0 });
    } else {
      if (staringCreateAtDate !== null) {
        if (endingCreateAtDate === null) {
          flag = false;
          setEndingRequestDateError(true);
        } else {
          setEndingRequestDateError(false);
        }
      }
      if (staringUpdateAtDate !== null) {
        if (endingUpdateAtDate === null) {
          flag = false;
          setEndingReturnDateError(true);
        } else {
          setEndingReturnDateError(false);
        }
      }
      if (staringPrice !== "") {
        if (endingPrice === "") {
          flag = false;
          setEndingPriceError(true);
        } else {
          setEndingPriceError(false);
        }
      }

      if (flag) {
        ProductStore.setProductFilterApply({
          value: ++ProductStore.productFilterApply,
        });
      }
    }
    if (flag) {
      handleClose();
    }
  };

  const clearAll = () => {
    ProductStore.setProductFilterApply({ value: 0 });
    setCategoryID("");
    setStaringCreateAtDate(null);
    setEndingCreateAtDate(null);
    setStaringUpdateAtDate(null);
    setEndingUpdateAtDate(null);
    setStaringPrice("");
    setEndingPrice("");
    setPublish("");
  };

  return (
    <div className="product-filter">
      <div className="filter-btn">
        <Chip
          avatar={
            <Avatar className="avatar">
              <FilterListRoundedIcon className="icon" />
            </Avatar>
          }
          label={<p>Filter</p>}
          variant="outlined"
          onClick={handleClickOpen}
        />
      </div>
      <Dialog
        fullScreen={max_width600 ? true : false}
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        fullWidth
        maxWidth="md"
      >
        {max_width600 ? (
          <AppBar sx={{ position: "relative" }}>
            <Toolbar style={{ background: "#000" }}>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
              >
                <CloseRoundedIcon />
              </IconButton>
              <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                Search Filter
              </Typography>
              <Button autoFocus color="inherit" onClick={handleApply}>
                Apply
              </Button>
            </Toolbar>
          </AppBar>
        ) : (
          <DialogTitle>Search Filter</DialogTitle>
        )}

        <DialogContent>
          <Grid container spacing={2}>
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  disabled={
                    ProductStore.productFilterApply === 0 ? true : false
                  }
                  onClick={clearAll}
                >
                  Clear All
                </Button>
              </div>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="delivery-publish">Status</InputLabel>
                <Select
                  labelId="delivery-publish"
                  value={categoryID}
                  label="Status"
                  onChange={(e) => {
                    if (e.target.value === "clear") {
                      setCategoryID("");
                    } else {
                      setCategoryID(e.target.value);
                    }
                  }}
                >
                  <MenuItem
                    value="clear"
                    disabled={categoryID === "" ? true : false}
                  >
                    Clear
                  </MenuItem>
                  {CategoryStore.category &&
                    CategoryStore.category.map((item) => (
                      <MenuItem value={item._id} key={item._id}>
                        {item.categoryName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item lg={6} md={6} sm={12} xs={12}>
              <FormControl fullWidth>
                <InputLabel id="delivery-publish">Status</InputLabel>
                <Select
                  labelId="delivery-publish"
                  value={publish}
                  label="Status"
                  onChange={(e) => {
                    if (e.target.value === "clear") {
                      setPublish("");
                    } else {
                      setPublish(e.target.value);
                    }
                  }}
                >
                  <MenuItem
                    value="clear"
                    disabled={publish === "" ? true : false}
                  >
                    Clear
                  </MenuItem>
                  <MenuItem value={true}>Publish</MenuItem>
                  <MenuItem value={false}>Draft</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Starting Request Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="staringCreateAtDate"
                    value={staringCreateAtDate}
                    onChange={(value) => {
                      setStaringCreateAtDate(value);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {staringCreateAtDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => {
                    setStaringCreateAtDate(null);
                    setEndingRequestDateError(false);
                  }}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Ending Request Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="endingCreateAtDate"
                    value={endingCreateAtDate}
                    onChange={(value) => {
                      setEndingCreateAtDate(value);
                      setEndingRequestDateError(false);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {endingRequestDateError && (
                <FormHelperText color="error">
                  ending date is required
                </FormHelperText>
              )}
              {endingCreateAtDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => setEndingCreateAtDate(null)}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Starting Return Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="startingReturnDate"
                    value={staringUpdateAtDate}
                    onChange={(value) => {
                      setStaringUpdateAtDate(value);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {staringUpdateAtDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => {
                    setStaringUpdateAtDate(null);
                    setEndingReturnDateError(false);
                  }}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={[
                    "DatePicker",
                    "DesktopDatePicker",
                    "MobileDatePicker",
                  ]}
                >
                  <DatePicker
                    label="Ending Return Date"
                    maxDate={dayjs(todayDate)}
                    format="DD/MM/YYYY"
                    name="endingUpdateAtDate"
                    value={endingUpdateAtDate}
                    onChange={(value) => {
                      setEndingUpdateAtDate(value);
                      setEndingReturnDateError(false);
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              {endingReturnDateError && (
                <FormHelperText color="error">
                  ending date is required
                </FormHelperText>
              )}
              {endingUpdateAtDate !== null && (
                <Button
                  sx={{ mt: 1, mb: -1 }}
                  onClick={() => setEndingUpdateAtDate(null)}
                  size="small"
                >
                  Clear
                </Button>
              )}
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Starting Price"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                fullWidth
                name="startingPrice"
                value={staringPrice}
                onChange={(e) => {
                  const { value } = e.target;
                  if (!isNaN(value)) {
                    setStaringPrice(value);
                  }
                }}
                InputProps={{
                  endAdornment: staringPrice !== "" && (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setStaringPrice("");
                        setEndingPriceError(false);
                      }}
                    >
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
              />
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <TextField
                label="Ending Price"
                variant="outlined"
                inputProps={{ inputMode: "numeric" }}
                fullWidth
                name="endingPrice"
                value={endingPrice}
                onChange={(e) => {
                  const { value } = e.target;
                  if (!isNaN(value)) {
                    setEndingPrice(value);
                    setEndingPriceError(false);
                  }
                }}
                InputProps={{
                  endAdornment: endingPrice !== "" && (
                    <IconButton size="small" onClick={() => setEndingPrice("")}>
                      <CloseRoundedIcon />
                    </IconButton>
                  ),
                }}
                error={endingPriceError}
                helperText={endingPriceError && "ending price is required"}
              />
            </Grid>
          </Grid>
        </DialogContent>
        {!max_width600 && (
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button onClick={handleApply}>Apply</Button>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
};

export default ProductFilter;
